/* Kiddier theme scripts */
(function(){
  "use strict";
  function safe(fn){ try{ fn(); }catch(e){ if(window.console) console.warn('[kiddier]', e); } }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- Reveal on scroll (robust) ---------- */
  var io = null;
  function revealAll(root){ (root||document).querySelectorAll('[data-reveal]').forEach(function(e){ e.classList.add('is-in'); }); }
  function ensureIO(){
    if(io || !('IntersectionObserver' in window)) return;
    io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold:0.08, rootMargin:'0px 0px -6% 0px' });
  }

  /* ---------- Add to cart without Shopify error-page redirects ---------- */
  function initProductForms(root){
    (root||document).querySelectorAll('form.product-form').forEach(function(form){
      if(form.dataset.cartReady === 'true') return;
      form.dataset.cartReady = 'true';
      form.addEventListener('submit', function(event){
        event.preventDefault();
        var button = form.querySelector('[name="add"]');
        var label = button ? button.querySelector('[data-add-label]') : null;
        var message = form.querySelector('[data-product-form-message]');
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var variantId = idField ? parseInt(idField.value,10) : 0;
        var quantity = qtyField ? Math.max(1,parseInt(qtyField.value,10)||1) : 1;
        if(button) button.disabled = true;
        if(label) label.textContent = 'Adding…';
        if(message){ message.textContent=''; message.classList.remove('is-error','is-success'); }
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method:'POST',
          headers:{'Accept':'application/json','Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({items:[{id:variantId,quantity:quantity}]})
        }).then(function(response){
          return response.json().then(function(data){
            if(!response.ok) throw new Error(data.description || data.message || 'add_failed');
            return data;
          });
        }).then(function(){
          window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
        }).catch(function(){
          if(button) button.disabled=false;
          if(label) label.textContent='Add to Cart';
          if(message){
            message.textContent='Unable to add this item right now. Please refresh the page and try again.';
            message.classList.add('is-error');
          }
        });
      });
    });
  }
  function observe(root){
    root = root || document;
    // In the theme editor or with reduced motion, never hide content.
    if(designMode || reduceMotion || !('IntersectionObserver' in window)){ revealAll(root); return; }
    ensureIO();
    root.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function(e){ io.observe(e); });
  }

  /* ---------- Header ---------- */
  function initHeader(){
    var header = document.querySelector('.header');
    if(!header || !header.classList.contains('header--transparent')) return;
    var hero = document.querySelector('.hero');
    function threshold(){ return hero ? Math.max(80, hero.offsetHeight - 110) : Math.max(80, window.innerHeight*0.55); }
    var t = threshold();
    window.addEventListener('resize', function(){ t = threshold(); }, {passive:true});
    function watch(){
      if(window.scrollY > t){ header.classList.add('header--solid'); header.classList.remove('header--transparent'); }
      else { header.classList.add('header--transparent'); header.classList.remove('header--solid'); }
    }
    window.addEventListener('scroll', watch, {passive:true});
    watch();
  }

  /* ---------- Announcement rotation ---------- */
  function initTopbar(){
    var bar = document.querySelector('[data-topbar]');
    if(!bar) return;
    var msgs = bar.querySelectorAll('[data-topbar-msg]');
    if(msgs.length < 2 || reduceMotion) return;
    var i = 0;
    setInterval(function(){ msgs[i].classList.remove('is-on'); i=(i+1)%msgs.length; msgs[i].classList.add('is-on'); }, 3800);
  }

  /* ---------- Mobile nav ---------- */
  function initMobileNav(){
    var toggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if(!toggle || !nav) return;
    var close = nav.querySelector('[data-nav-close]');
    function open(){ nav.classList.add('is-open'); document.body.style.overflow='hidden'; }
    function shut(){ nav.classList.remove('is-open'); document.body.style.overflow=''; }
    toggle.addEventListener('click', open);
    if(close) close.addEventListener('click', shut);
    nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', shut); });
  }

  /* ---------- Homepage featured gallery + qty ---------- */
  function initFeature(root){
    (root||document).querySelectorAll('[data-feature]').forEach(function(el){
      var main = el.querySelector('[data-feature-main]');
      el.querySelectorAll('[data-feature-thumb]').forEach(function(t){
        t.addEventListener('click', function(){
          var src = t.getAttribute('data-src');
          if(main && src) main.src = src;
          el.querySelectorAll('[data-feature-thumb]').forEach(function(x){ x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
      var qty = el.querySelector('[data-qty-input]'), minus = el.querySelector('[data-qty-minus]'), plus = el.querySelector('[data-qty-plus]');
      if(qty && minus && plus){
        minus.addEventListener('click', function(){ qty.value = Math.max(1,(parseInt(qty.value,10)||1)-1); });
        plus.addEventListener('click', function(){ qty.value = (parseInt(qty.value,10)||1)+1; });
      }
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root){
    (root||document).querySelectorAll('.pdp').forEach(function(pdp){
      // thumbnails + mobile swipe
var main = pdp.querySelector('[data-pdp-main]');
var thumbs = Array.from(pdp.querySelectorAll('[data-pdp-thumb]'));

function showImage(index){
  if(!main || !thumbs.length) return;

  if(index < 0) index = thumbs.length - 1;
  if(index >= thumbs.length) index = 0;

  var src = thumbs[index].getAttribute('data-src');
  if(src) main.src = src;

  thumbs.forEach(function(x){
    x.classList.remove('is-active');
  });

  thumbs[index].classList.add('is-active');
}

thumbs.forEach(function(t, index){
  t.addEventListener('click', function(){
    showImage(index);
  });
});

if(main && thumbs.length > 1){
  var touchStartX = 0;
  var touchStartY = 0;

  main.addEventListener('touchstart', function(e){
    touchStartX = e.changedTouches[0].clientX;
    touchStartY = e.changedTouches[0].clientY;
  }, { passive: true });

  main.addEventListener('touchend', function(e){
    var diffX = e.changedTouches[0].clientX - touchStartX;
    var diffY = e.changedTouches[0].clientY - touchStartY;

    // Ignore vertical scrolling and very short swipes
    if(Math.abs(diffX) < 40 || Math.abs(diffX) < Math.abs(diffY)) return;

    var current = thumbs.findIndex(function(x){
      return x.classList.contains('is-active');
    });

    if(current < 0) current = 0;

    // Swipe left = next image
    if(diffX < 0){
      showImage(current + 1);
    } else {
      // Swipe right = previous image
      showImage(current - 1);
    }
  }, { passive: true });
}

      // variant picker
      var picker = pdp.querySelector('[data-variant-picker]');
      var idField = pdp.querySelector('[data-variant-id]');
      if(picker && idField){
        var variants = [];
        var variantJson = picker.querySelector('[data-variant-json]');
        try{ variants = JSON.parse(variantJson ? variantJson.textContent : '[]'); }catch(e){}
        function selected(){
          var vals = [];
          picker.querySelectorAll('.pdp__opt').forEach(function(opt, idx){
            var r = opt.querySelector('input[type=radio]:checked');
            if(r) vals[idx] = r.value;
          });
          return vals;
        }
        function match(){
          var vals = selected();
          var v = variants.find(function(vr){
            return (vr.options||[]).every(function(o,i){ return o === vals[i]; });
          });
          if(v && !v.available){
            v = variants.find(function(vr){ return vr.available; }) || v;
          }
          if(v){
            idField.value = v.id;
            var addBtn = pdp.querySelector('[name=add]');
            if(addBtn){
              addBtn.disabled = false;
              var label = addBtn.querySelector('[data-add-label]');
              if(label) label.textContent = 'Add to Cart';
            }
            if(window.history && window.history.replaceState){
              var url = new URL(window.location.href);
              url.searchParams.set('variant', v.id);
              window.history.replaceState({}, '', url);
            }
          }
        }
        picker.querySelectorAll('input[type=radio]').forEach(function(r){
          r.addEventListener('change', function(){
            var group = r.closest('.pdp__opt');
            group.querySelectorAll('.swatch').forEach(function(s){ s.classList.remove('is-active'); });
            if(r.closest('.swatch')) r.closest('.swatch').classList.add('is-active');
            var cur = group.querySelector('[data-opt-current]'); if(cur) cur.textContent = r.value;
            match();
          });
        });
      }

      // bundles -> quantity
      var qtyField = pdp.querySelector('[data-qty-field]');
      pdp.querySelectorAll('[data-bundle]').forEach(function(b){
        b.addEventListener('click', function(){
          pdp.querySelectorAll('[data-bundle]').forEach(function(x){ x.classList.remove('is-active'); });
          b.classList.add('is-active');
          var radio = b.querySelector('input[type=radio]'); if(radio) radio.checked = true;
          if(qtyField) qtyField.value = b.getAttribute('data-qty') || '1';
        });
      });
    });

    // sticky mobile buy bar
    var sticky = (root||document).querySelector('[data-pdp-sticky]');
    var formId = sticky ? sticky.getAttribute('data-form-id') : '';
    var form = formId ? document.getElementById(formId) : null;
    var addBtn = form ? form.querySelector('[name=add]') : null;
    if(sticky && addBtn){
      var stickyAdd = sticky.querySelector('[data-pdp-sticky-add]');
      if(stickyAdd) stickyAdd.addEventListener('click', function(){ if(addBtn.requestSubmit){ addBtn.form.requestSubmit(addBtn); } else { addBtn.click(); } });
      function onScroll(){
        var r = addBtn.getBoundingClientRect();
        if(r.bottom < 0){ sticky.classList.add('is-on'); } else { sticky.classList.remove('is-on'); }
      }
      window.addEventListener('scroll', onScroll, {passive:true});
      onScroll();
    }
  }

  /* ---------- Cart count ---------- */
  function initCart(){
    var badges = document.querySelectorAll('[data-cart-count]');
    if(!badges.length) return;
    fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(c){ badges.forEach(function(b){ b.textContent = c.item_count; b.style.display = c.item_count>0 ? 'grid':'none'; }); })
      .catch(function(){});
  }

  function boot(root){
    safe(function(){ initFeature(root); });
    safe(function(){ initProduct(root); });
    safe(function(){ initProductForms(root); });
    safe(function(){ observe(root); });
  }

  document.addEventListener('DOMContentLoaded', function(){
    safe(initTopbar); safe(initHeader); safe(initMobileNav); safe(initCart);
    safe(function(){ observe(document); });
    safe(function(){ initFeature(document); });
    safe(function(){ initProduct(document); });
    safe(function(){ initProductForms(document); });
  });

  // Safety net: never leave content hidden after load
  window.addEventListener('load', function(){
    safe(function(){
      document.querySelectorAll('[data-reveal]:not(.is-in)').forEach(function(e){
        var r = e.getBoundingClientRect();
        if(r.top < (window.innerHeight||800) * 1.25) e.classList.add('is-in');
      });
    });
  });

  // Shopify Theme Editor: re-init reloaded sections and always show them
  document.addEventListener('shopify:section:load', function(e){ safe(function(){ revealAll(e.target); boot(e.target); initTopbar(); initHeader(); }); });
  document.addEventListener('shopify:section:select', function(e){ safe(function(){ revealAll(e.target); }); });
})();
